let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jGOT0")).then(() => parcelRequire('gLajM'));